module.exports = __webpack_public_path__ + "img/anim_cube_loading-tiny.59c43dfd.png";